import * as GraphqlImporter from './graphql-importer'
import commonRequestApi from '../../request'
import Response from '../../Response'
import { DocumentNode } from 'graphql'

export const SERVER_URL = '/web/gql/PlatformTrade'

// 枚举
export enum StudentIdentityOperateTypeEnum {
  RENEWED = 'RENEWED',
  CURTAILED = 'CURTAILED'
}
export enum PaymentChannelTypeEnum {
  WEB = 'WEB',
  ANDROID = 'ANDROID',
  IOS = 'IOS',
  WECHAT_OFFICIAL_ACCOUNTS = 'WECHAT_OFFICIAL_ACCOUNTS',
  WECHAT_MINI_PROGRAMS = 'WECHAT_MINI_PROGRAMS',
  PRESENT = 'PRESENT',
  COLLECTIVE = 'COLLECTIVE',
  HTML5 = 'HTML5',
  CHANNEL_PRESENT_OPEN = 'CHANNEL_PRESENT_OPEN'
}
export enum ContentType {
  INDUSTRY_CATEGORY = 'INDUSTRY_CATEGORY',
  MAJOR = 'MAJOR'
}
export enum PayMode {
  onlyCurrency = 'onlyCurrency',
  currencyAndElectronicWallet = 'currencyAndElectronicWallet',
  onlyElectronicWallet = 'onlyElectronicWallet'
}
export enum InvoiceType {
  NORMAL = 'NORMAL',
  VAT_NORMAL = 'VAT_NORMAL',
  VAT_SPECIAL = 'VAT_SPECIAL'
}
export enum InvoiceTitleType {
  NONE = 'NONE',
  PERSONAL = 'PERSONAL',
  ENTERPRISE = 'ENTERPRISE'
}
export enum MerchantAccountCreateType {
  INTERNAL = 'INTERNAL',
  NORMAL = 'NORMAL',
  AUTHORIZE = 'AUTHORIZE'
}

// 类

export class Page {
  pageNo?: number
  pageSize?: number
}

/**
 * @author: eleven
@since: 2018/5/10 19:16
@description:
 */
export class BillConfigQueryDTO {
  /**
   * 缴费渠道
   */
  placeChannelEnum?: PaymentChannelTypeEnum
}

/**
 * 培训机构查询参数
 */
export class TeachUnitQueryDTO {
  /**
   * 单位名称
   */
  name?: string
  /**
   * 单位地区 省
   */
  provinceId?: string
  /**
   * 单位地区 市
   */
  cityId?: string
  /**
   * 单位地区 区县
   */
  countyId?: string
}

/**
 * 发票查询参数
@author yeyc create 2020/4/22 13:47
 */
export class LazyBillRequestParam {
  /**
   * 收款账号id
   */
  receiptAccount?: string
  /**
   * 主订单号
   */
  orderNos?: Array<string>
  /**
   * 购买人姓名
   */
  buyerName?: string
  /**
   * 购买人身份证号
   */
  buyerIdentity?: string
  /**
   * 购买人手机号
   */
  buyerPhoneNumber?: string
  /**
   * 蓝票开具状态：0未开票、1开票中、2开票成功、3开票失败
   */
  blueState?: Array<number>
  /**
   * 红票开具状态：0未开票、1开票中、2开票成功、3开票失败
   */
  redState?: Array<number>
  /**
   * 是否冲红
true 是
false 否
   */
  redBill?: boolean
  /**
   * 是否冻结
   */
  frozen?: boolean
  /**
   * 发票代码
   */
  billCode?: string
  /**
   * 发票验证码
   */
  billVeriCode?: string
  /**
   * 索取发票开始时间
   */
  getBillStartTime?: string
  /**
   * 索取发票结束时间
   */
  getBillEndTime?: string
  /**
   * 发票类型：1普通发票，2增值税普通发票，3增值税专用发票
   */
  invoiceType?: string
  /**
   * 是否开票
   */
  makeInvoice?: boolean
  /**
   * 开票开始时间
   */
  makeInvoiceStartTime?: string
  /**
   * 开票结束时间
   */
  makeInvoiceEndTime?: string
  /**
   * 是否非税务发票
   */
  noTaxBill?: boolean
  /**
   * 是否电子发票
   */
  electron?: boolean
  /**
   * 是否测试数据
   */
  test?: boolean
  /**
   * 订单所属培训机构
单位id
   */
  unitIdList?: Array<string>
  /**
   * 发票号
   */
  billNo?: string
  /**
   * 发票抬头
   */
  billTitle?: string
  /**
   * 发票抬头类别
   */
  billTitleType?: string
}

/**
 * 延迟查询订单的查询参数
@author yeyc create 2020/3/11 11:27
 */
export class LazyOrderQueryParam {
  /**
   * 订单号
   */
  orderNo?: string
  /**
   * 收款账号id
   */
  receiveAccountId?: string
  /**
   * 银行交易流水号
   */
  payFlowNo?: string
  /**
   * 用户id
   */
  userIds?: Array<string>
  /**
   * 手机号码(后台根据这个获取用户id)
   */
  buyerPhoneNumber?: string
  /**
   * 证件号(后台根据这个获取用户id)
   */
  buyerIdentity?: string
  /**
   * 交易状态
   */
  status?: Array<number>
  /**
   * 下单渠道
   */
  placeChannel?: string
  /**
   * 单位id （所属培训机构id）
   */
  unitIdList?: Array<string>
  /**
   * 方案id
   */
  schemeId?: string
  /**
   * 方案idList
   */
  schemeIdList?: Array<string>
  /**
   * 订单创建开始时间 >
   */
  createStartTime?: string
  /**
   * 订单创建结束时间 <&#x3D;
   */
  createEndTime?: string
  /**
   * 订单完成开始时间 >
   */
  completeStartTime?: string
  /**
   * 订单创建结束时间 <&#x3D;
   */
  completeEndTime?: string
  /**
   * 是否为补考
   */
  makeUpExam?: boolean
  /**
   * 是否为0元订单
   */
  zeroOrder?: boolean
  /**
   * 是否为延期
   */
  isDelay?: boolean
}

/**
 * 退款查询参数
@author yeyc create 2020/4/14 11:40
 */
export class LazyRefundOrderParam {
  /**
   * 退款对应的主订单号
   */
  orderNo?: string
  /**
   * 退款对应的子订单号
   */
  subOrderNo?: string
  /**
   * 银行交易流水号
   */
  bankTrasactionNumber?: string
  /**
   * 所属培训方案id
   */
  schemeId?: string
  /**
   * 所属培训方案id集合
   */
  schemeIdList?: Array<string>
  /**
   * 所属期别id
   */
  issueId?: string
  /**
   * 交易渠道信息   web、小程序、公众号
@see PaymentChannelTypeEnum
   */
  placeChannel?: string
  /**
   * 单位id （所属培训机构id）
   */
  unitIdList?: Array<string>
  /**
   * 退款对应的订单是否补考
   */
  makeUpExam?: boolean
  /**
   * 退款订单状态
   */
  refundStatus?: Array<number>
  /**
   * 退款申请时间
   */
  applyStartTime?: string
  /**
   * 退款申请时间
   */
  applyEndTime?: string
  /**
   * 收款账号id
   */
  receiveAccountId?: string
}

/**
 * 我的订单查询参数对象
 */
export class MyOrderQueryDTO {
  /**
   * 订单号
   */
  orderNo?: string
  /**
   * 订单状态
   */
  states?: Array<number>
  /**
   * 订单购买的商品名称
   */
  productName?: string
  /**
   * 订单创建结束时间 >&#x3D;
yyyy-mm-dd 24hh:MM:dd
   */
  createStartTime?: string
  /**
   * 订单创建开始时间 <
yyyy-mm-dd 24hh:MM:dd
   */
  createEndTime?: string
  /**
   * 订单商品
   */
  commonditySkuId?: string
  /**
   * 订单号或商品名
   */
  orderNoOrProductName?: string
}

/**
 * 上架方案查询参数对象
 */
export class PreExamLSQueryDTO {
  /**
   * 年度id
   */
  yearCode?: number
  /**
   * 行业id
   */
  industryId?: string
  /**
   * 专业id
   */
  majorId?: string
  /**
   * 方案名称
   */
  schemeName?: string
}

/**
 * 查询对象
 */
export class MerchantAccountQuery {
  /**
   * 支付方式(1:代表线上;2:代表线下)
   */
  payType: number
  /**
   * 缴费渠道
   */
  placeChannelEnum?: PaymentChannelTypeEnum
}

/**
 * 商品信息
@author yeyc create 2020/3/5 14:28
 */
export class CommodityInfoDTO {
  /**
   * 商品skuid
   */
  commoditySkuId: string
  /**
   * 期数ID  (前端需要取这个id做期别id)
   */
  issueId: string
  /**
   * 期别ID(暂时没用)
   */
  stageId: string
  /**
   * 期别标题（期别名称）
   */
  title: string
  /**
   * 方案id
   */
  schemeId: string
  /**
   * 培训方案名称
   */
  schemeName: string
  /**
   * 考试类别ID
   */
  examTypeId: string
  /**
   * 专业ID
   */
  professionId: string
  /**
   * 方案推荐指数
产品要求为前端写死，该字段暂时无用
   */
  recommendIndex: number
  /**
   * 年度id
   */
  year: number
  /**
   * 开始时间
   */
  startTime: string
  /**
   * 结束时间
   */
  endTime: string
  /**
   * 线下考试时间
   */
  offlineExamTime: string
  /**
   * 销售价格
   */
  price: number
  /**
   * 班级图片
   */
  picture: string
}

/**
 * graphql没有泛型的操作结果类
@author yeyc create 2020/3/9 15:18
 */
export class GraphqlOperateResult {
  /**
   * 返回的code
   */
  code: string
  /**
   * 返回的message
   */
  message: string
  /**
   * json字段
存放返回的参数用
   */
  expandData: Map<string, string>
}

/**
 * 订单的支付信息对象
 */
export class PayInfoDTO {
  /**
   * 支付流水, 支付中就有
【分页时没有值】
   */
  payFlowNo: string
  /**
   * 支付方式  支付方式 1：线上支付 2：线下支付
   */
  payType: number
  /**
   * 订单实付总金额
   */
  totalAmount: number
  /**
   * 支付方式
   */
  payMode: PayMode
  /**
   * 成功付款时间, yyyy-mm-dd 24hh:MM:dd
   */
  successPayTime: string
}

/**
 * 方案内展示课程讲师树状对象
@author yeyc create 2020/3/5 13:53
 */
export class PreExamLSCourseDTO {
  /**
   * 课程ID
   */
  id: string
  /**
   * 课程名称
   */
  name: string
  /**
   * 封面图片路径
   */
  iconPath: string
  /**
   * 权重,表示学时,学分等
   */
  period: number
  /**
   * 课程简介
   */
  abouts: string
  /**
   * 课程内讲师
   */
  teacherList: Array<TeacherSimpleDTO>
}

/**
 * 学员收款账号对象
 */
export class StudentMerchantAccountDTO {
  /**
   * 账户别名
   */
  accountAlias: string
  /**
   * 账户账号
   */
  accountNo: string
  /**
   * 支付渠道的code
   */
  code: string
  /**
   * 支付渠道的logoPath
   */
  logoPath: string
  /**
   * 支付类型 1线上 2线下
   */
  payType: number
  /**
   * 开户人
   */
  merchantName: string
  /**
   * 开户银行
   */
  depositBank: string
  /**
   * 在对应渠道是否可用
   */
  channelUsable: boolean
  /**
   * 账户id
   */
  id: string
  /**
   * 创建单位id
   */
  unitId: string
  /**
   * 收款账号的创建方式
   */
  createType: MerchantAccountCreateType
}

/**
 * 退款原因
@author yeyc create 2020/4/13 16:14
 */
export class OrderRefundReasonDTO {
  /**
   * 原因id
   */
  id: string
  /**
   * 原因名称
   */
  name: string
}

export class TeachUnitBaseDTO {
  /**
   * 单位id
   */
  unitId: string
  /**
   * 单位名称
   */
  name: string
  /**
   * 组织机构代码
   */
  organizationCode: string
  /**
   * 单位地区
   */
  provinceId: string
  /**
   * 单位地区 市
   */
  cityId: string
  /**
   * 单位地区 区县
   */
  countyId: string
  /**
   * 状态
   */
  status: string
  /**
   * 门户名称
   */
  portalName: string
}

export class TeachUnitInfoDTO {
  unitId: string
  name: string
  organizationCode: string
  provinceId: string
  cityId: string
  countyId: string
  status: string
  portalName: string
  logoUrl: string
  bannerUrls: Array<string>
  portalFooterDescribe: string
  onlineCustomerInfo: string
  customerPhone: string
  defaultUnitDomain: UnitDomainDTO
}

/**
 * 培训机构分页返回
 */
export class TeachUnitPageDTO {
  id: string
  platformId: string
  platformVersionId: string
  projectId: string
  subProjectId: string
  name: string
  organizationCode: string
  provinceId: string
  cityId: string
  countyId: string
  defaultUnitDomainId: string
  defaultUnitDomain: UnitDomainDTO
  portalName: string
  logoUrl: string
  bannerUrls: Array<string>
  portalFooterDescribe: string
  onlineCustomerInfo: string
  customerPhone: string
  status: string
  teachManager: TeachAdministratorDTO
}

export class TeacherSimpleDTO {
  /**
   * 教师ID
   */
  id: string
  /**
   * 教师名称
   */
  name: string
  /**
   * 教师头像
   */
  photo: string
  /**
   * 教师简介
   */
  abouts: string
}

/**
 * 学员身份操作记录（延期、删减）
Author:FangKunSen
Time:2020-10-27,16:24
 */
export class StudentIdentityOperateRecordDTO {
  /**
   * 操作者id
   */
  operatorId: string
  /**
   * 操作者名
   */
  operatorName: string
  /**
   * 操作时间
   */
  operatorTime: string
  /**
   * 操作类型
   */
  operateType: StudentIdentityOperateTypeEnum
  /**
   * 改动天数
   */
  modifyDays: number
}

/**
 * 订单的发票信息
 */
export class BillOrderInfoDTO {
  /**
   * 主键 主订单号
   */
  orderNo: string
  /**
   * 买家ID
   */
  buyerId: string
  /**
   * 主键 发票ID
   */
  id: string
  /**
   * 发票抬头
   */
  title: string
  /**
   * 发票抬头类型 1：个人 2：企业
   */
  titleType: string
  /**
   * 统一社会信用代码
   */
  taxpayerNo: string
  /**
   * 地址
   */
  address: string
  /**
   * 电话
   */
  phone: string
  /**
   * 开户行
   */
  bankName: string
  /**
   * 账号
   */
  account: string
  /**
   * 发票类型：1普通发票，2增值税普通发票，3增值税专用发票
   */
  invoiceType: string
  /**
   * 是否测试数据
   */
  test: boolean
  /**
   * 发票状态 1：未确认 2：已确认3：等待打印 4：打印中 5：打印成功 6：入库中 7：入库成功 8：入库失败
   */
  state: string
}

/**
 * 年度对象
 */
export class YearDTO {
  /**
   * 年度id
   */
  id: string
  /**
   * 年度code
   */
  yearCode: number
}

/**
 * 期数信息
对应前端的期别（原来叫期别，后面期别隐藏了，后端叫期数）
 */
export class IssueDTO {
  /**
   * 学习方案ID
   */
  schemeId: string
  /**
   * 期数ID（对应前端期别）
   */
  issueId: string
  /**
   * 商品SkuId
   */
  commoditySkuId: string
  /**
   * 标题
   */
  title: string
  /**
   * 开始时间
   */
  startTime: string
  /**
   * 结束时间
   */
  endTime: string
  /**
   * 线下考试时间
   */
  offlineExamTime: string
  /**
   * 销售价格
   */
  price: number
}

/**
 * 类说明
@author yeyc create 2020/4/14 11:49
 */
export class LazyCommodityInfoDTO {
  /**
   * 商品id
   */
  commodityId: string
  /**
   * 所属培训方案名称
   */
  schemeName: string
  /**
   * 所属培训方案id
   */
  schemeId: string
  /**
   * 所属期别(期数)名称
   */
  issueTitle: string
  /**
   * 所属期别id
   */
  stageId: string
  /**
   * 所属期数id
   */
  issueId: string
  /**
   * 子订单商品年度 属性key
   */
  yearPropertyId: string
  /**
   * 子订单商品年度
   */
  year: string
  /**
   * 子订单商品年度 年度名称
   */
  yearName: string
  /**
   * 子订单商品专业id
   */
  professionId: string
  /**
   * 子订单商品专业id 属性key
   */
  professionPropertyId: string
  /**
   * 子订单商品专业名称
   */
  professionName: string
  /**
   * 子订单商品行业id 属性key
   */
  professionTypePropertyId: string
  /**
   * 子订单商品行业id
   */
  professionTypeId: string
  /**
   * 子订单商品类别、 行业名称
   */
  professionTypeName: string
}

/**
 * lazy订单的分页对象
@author yeyc create 2020/3/17 14:08
 */
export class LazyOrderDTO {
  orderNo: string
  /**
   * 订单所属单位ID
   */
  unitId: string
  /**
   * 订单所属单位名称
   */
  unitName: string
  /**
   * 交易渠道信息   web、小程序、公众号
@see PaymentChannelTypeEnum
   */
  placeChannel: string
  /**
   * 是否需要发票
   */
  needBill: boolean
  /**
   * 订单总金额
   */
  totalAmount: number
  /**
   * 是否为补考
   */
  makeUpExam: boolean
  /**
   * 收款账号id
   */
  receiveAccountId: string
  /**
   * 主订单状态
   */
  status: number
  /**
   * 是否是测试数据
   */
  test: boolean
  /**
   * （用来记录学员侧删除订单）
是否被学员标记为隐藏
   */
  signHide: boolean
  /**
   * 订单应用类型 1:普通订单,2:换货生成的新订单
   */
  applyType: number
  /**
   * 订单创建时间, yyyy-mm-dd 24hh:MM:dd
   */
  createTime: string
  /**
   * 完成交易的时间, yyyy-mm-dd 24hh:MM:dd
   */
  completeTime: string
  /**
   * 订单开货时间 yyyy-mm-dd 24hh:MM:dd
   */
  deliverTime: string
  /**
   * 订单自动关闭时间
   */
  autoCloseTime: string
  /**
   * 卖家id
   */
  sellerId: string
  /**
   * 卖家名称
   */
  sellerName: string
  /**
   * 买家id
   */
  buyerId: string
  /**
   * 买家姓名
   */
  buyerName: string
  /**
   * 买家电话号码
   */
  buyerPhoneNumber: string
  /**
   * 买家身份证号码
   */
  buyerIdentity: string
  /**
   * 买家登录账户
   */
  buyerLoginInput: string
  /**
   * 支付方式  支付方式 1：线上支付 2：线下支付,-1:表示未支付
   */
  payType: number
  /**
   * 微信支付。支付宝支付
   */
  tradeChannelCode: string
  /**
   * 微信支付。支付宝支付
   */
  tradeChannelCodeName: string
  /**
   * 成功付款时间, yyyy-mm-dd 24hh:MM:dd
   */
  successPayTime: string
  /**
   * 主订单实付总价
   */
  orderTotalPayAmount: number
  /**
   * 银行交易流水号
   */
  payFlowNo: string
  /**
   * 商品创建人id
   */
  productCreateUserId: string
  /**
   * 期数开始时间
   */
  issueStartTime: string
  /**
   * 期数结束时间
   */
  issueEndTime: string
  /**
   * 期数线下考试时间
   */
  issueOfflineExamTime: string
  /**
   * 退款订单号
   */
  refundOrderNo: string
  /**
   * 退款类型
   */
  refundType: string
  /**
   * 退款申请人id
   */
  refundApplyUserId: string
  /**
   * 退款申请时间
   */
  refundApplyTime: string
  /**
   * 退款原因id
   */
  refundReasonId: string
  /**
   * 退款总金额
   */
  refundTotalAmount: number
  /**
   * 退款方式 1.线上 2.线下
   */
  refundWay: number
  /**
   * 退款状态 1.已申请   2.退款成功 3.退款失败
与底层状态不同，只关心最终状态。
如果是拒绝退款就直接清空退款的数据了
   */
  refundStatus: number
  /**
   * 退款完成时间
   */
  refundCompleteTime: string
  /**
   * 主键 发票ID
   */
  billId: string
  /**
   * 发票类型：1普通发票，2增值税普通发票，3增值税专用发票
   */
  invoiceType: InvoiceType
  /**
   * 发票抬头类型
   */
  titleType: InvoiceTitleType
  /**
   * 是否电子票
   */
  electron: boolean
  /**
   * 发票抬头
   */
  title: string
  /**
   * 统一社会信用代码
   */
  taxpayerNo: string
  /**
   * 开户行
   */
  billBankName: string
  /**
   * 账号
   */
  billAccount: string
  /**
   * 地址
   */
  billAddress: string
  /**
   * 电话
   */
  billPhone: string
  /**
   * 是否非税发票
   */
  noTaxBill: boolean
  /**
   * 发票状态
发票状态暂时先不对接事件，暂时没用到
该字段索引留着，具体先不用
   */
  billStatus: number
  /**
   * 本条记录的创建时间
   */
  recordCreateTime: string
  /**
   * 本条记录的最后更新时间
   */
  recordLastUpdateTime: string
  /**
   * 子订单对象
   */
  lazySubOrderList: Array<LazySubOrderDTO>
  /**
   * 账号有效期是否有延期
   */
  identityEffectiveHasRenewedOnce: boolean
  /**
   * 账号有效期是否有删减过
   */
  identityEffectiveHasCurtailedOnce: boolean
  /**
   * 延期的操作记录
   */
  studentIdentityOperateRecordDTOList: Array<StudentIdentityOperateRecordDTO>
  /**
   * 账号有效期生效时间
   */
  identityEffectiveEffectTime: string
  /**
   * 账号有效期到期时间
   */
  identityEffectiveExpireTime: string
}

/**
 * 订单统计信息对象
@author yeyc create 2020/3/13 9:27
 */
export class LazyOrderStatisticsDTO {
  /**
   * 订单成交笔数
   */
  orderCount: number
  /**
   * 订单成交总额
   */
  totalAmount: number
  /**
   * 补考成交总额
   */
  makeUpExamAmount: number
  /**
   * 补考成交总额
   */
  makeUpExamCount: number
}

/**
 * 退款统计信息
@author yeyc create 2020/4/14 14:14
 */
export class LazyRefunOrderStatisticsDTO {
  /**
   * 退款总笔数
   */
  refunOrderCount: number
  /**
   * 退款总额
   */
  totalAmountCount: number
  /**
   * 补考总笔数
   */
  totalMakeUpCount: number
  /**
   * 补考总额
   */
  totalMakeUpAmountCount: number
}

/**
 * 退款分页信息对象
@author yeyc create 2020/4/14 11:45
 */
export class LazyRefundOrderDTO {
  /**
   * 退款订单号
   */
  refundOrderNo: string
  /**
   * 退款对应的主订单号
   */
  orderNo: string
  /**
   * 退款对应的子订单号
   */
  subOrderNo: string
  /**
   * 交易渠道信息   web、小程序、公众号
   */
  placeChannel: string
  /**
   * 退款总金额
   */
  refundTotalAmount: number
  /**
   * 卖家id
   */
  sellerId: string
  /**
   * 卖家名称
   */
  sellerName: string
  /**
   * 买家id
   */
  buyerId: string
  /**
   * 买家姓名
   */
  buyerName: string
  /**
   * 买家电话号码
   */
  buyerPhoneNumber: string
  /**
   * 买家身份证号码
   */
  buyerIdentity: string
  /**
   * 买家登录账户
   */
  buyerLoginInput: string
  /**
   * 退款订单状态
   */
  refundStatus: number
  /**
   * 退款申请时间
   */
  applyTime: string
  /**
   * 退款完成时间
   */
  refundCompleteTime: string
  /**
   * 退款商品信息
   */
  commodityInfoDTO: LazyCommodityInfoDTO
  /**
   * 创建方式
1:系统创建
2:用户创建
3:管理员创建
4:历史迁移
5:外部接口
   */
  createType: number
  /**
   * 商品标价
   */
  subOrderLabelPrice: number
  /**
   * 商品购买数量
   */
  purchaseQuantity: number
  /**
   * 银行交易流水号
   */
  bankTrasactionNumber: string
  /**
   * 退款方式 1.线上 2.线下
   */
  refundWay: number
  /**
   * 退款原因id
   */
  refundReasonId: string
  /**
   * 退款单是否补考
   */
  makeUpExam: boolean
  /**
   * 同意退款申请时间
   */
  agreeApplyTime: string
  /**
   * 取消退款时间
   */
  cancelTime: string
  /**
   * 拒绝退款时间
   */
  rejectTime: string
  /**
   * 资源回收时间
   */
  recycledTime: string
  /**
   * 同意退款时间
   */
  agreeTime: string
  /**
   * 已退款时间
退钱的时间
   */
  refundTime: string
  /**
   * 退款对应订单的单位id
   */
  orderUnitId: string
  /**
   * 退款申请审核人
   */
  agreeApplyUserId: string
  /**
   * 退款类型
   */
  refundType: number
}

/**
 * 退款详细
@author yeyc create 2020/4/14 14:07
 */
export class LazyRefundOrderDetailsDTO {
  /**
   * 申请人id
   */
  applyUserId: string
  /**
   * 申请人
   */
  applyUserName: string
  /**
   * 取消退款人id
   */
  cancelUserId: string
  /**
   * 取消退款人
   */
  cancelUserName: string
  /**
   * 同意退款申请人
   */
  agreeApplyUserName: string
  /**
   * 拒绝退款申请人id
   */
  rejectUserId: string
  /**
   * 拒绝退款申请人
   */
  rejectUserName: string
  /**
   * 同意退款人id
   */
  agreeUserId: string
  /**
   * 同意退款人
   */
  agreeUserName: string
  /**
   * 退款原因
   */
  reason: string
  /**
   * 申请退款描述
   */
  description: string
  /**
   * 拒绝申请原因描述
   */
  refuseApplyDesc: string
  /**
   * 拒绝退款原因描述
   */
  refuseRefundDesc: string
  /**
   * 退款订单号
   */
  refundOrderNo: string
  /**
   * 退款对应的主订单号
   */
  orderNo: string
  /**
   * 退款对应的子订单号
   */
  subOrderNo: string
  /**
   * 交易渠道信息   web、小程序、公众号
   */
  placeChannel: string
  /**
   * 退款总金额
   */
  refundTotalAmount: number
  /**
   * 卖家id
   */
  sellerId: string
  /**
   * 卖家名称
   */
  sellerName: string
  /**
   * 买家id
   */
  buyerId: string
  /**
   * 买家姓名
   */
  buyerName: string
  /**
   * 买家电话号码
   */
  buyerPhoneNumber: string
  /**
   * 买家身份证号码
   */
  buyerIdentity: string
  /**
   * 买家登录账户
   */
  buyerLoginInput: string
  /**
   * 退款订单状态
   */
  refundStatus: number
  /**
   * 退款申请时间
   */
  applyTime: string
  /**
   * 退款完成时间
   */
  refundCompleteTime: string
  /**
   * 退款商品信息
   */
  commodityInfoDTO: LazyCommodityInfoDTO
  /**
   * 创建方式
1:系统创建
2:用户创建
3:管理员创建
4:历史迁移
5:外部接口
   */
  createType: number
  /**
   * 商品标价
   */
  subOrderLabelPrice: number
  /**
   * 商品购买数量
   */
  purchaseQuantity: number
  /**
   * 银行交易流水号
   */
  bankTrasactionNumber: string
  /**
   * 退款方式 1.线上 2.线下
   */
  refundWay: number
  /**
   * 退款原因id
   */
  refundReasonId: string
  /**
   * 退款单是否补考
   */
  makeUpExam: boolean
  /**
   * 同意退款申请时间
   */
  agreeApplyTime: string
  /**
   * 取消退款时间
   */
  cancelTime: string
  /**
   * 拒绝退款时间
   */
  rejectTime: string
  /**
   * 资源回收时间
   */
  recycledTime: string
  /**
   * 同意退款时间
   */
  agreeTime: string
  /**
   * 已退款时间
退钱的时间
   */
  refundTime: string
  /**
   * 退款对应订单的单位id
   */
  orderUnitId: string
  /**
   * 退款申请审核人
   */
  agreeApplyUserId: string
  /**
   * 退款类型
   */
  refundType: number
}

/**
 * 子订单对象
@author yeyc create 2020/3/17 14:09
 */
export class LazySubOrderDTO {
  /**
   * 子订单号
   */
  subOrderNo: string
  /**
   * 成交单价
   */
  subOrderDealPrice: number
  /**
   * 购买数量
   */
  subOrderPurchaseQuantity: number
  /**
   * 子订单最后一次状态变更的时间
   */
  lastUpdateTime: string
  /**
   * 子订单状态
1 - 待付款
2 - 未发货
3 - 发货中
4 - 已发货
5 - 买家已签收
6 - 已换货
7 - 退货中
8 - 已退货
9 - 已取消
@see com.fjhb6.ability.order.v1.core.model.enums.SubOrderStatus
   */
  subOrderStatus: number
  /**
   * 完成交易的时间, yyyy-mm-dd 24hh:MM:dd
   */
  subOrderCompleteTime: string
  /**
   * 子订单发货的时间, yyyy-mm-dd 24hh:MM:dd
   */
  subOrderDeliverTime: string
  /**
   * 商品id
   */
  productId: string
  /**
   * 商品标价
   */
  subOrderLabelPrice: number
  /**
   * 所属培训方案名称
   */
  schemeName: string
  /**
   * 所属培训方案id
   */
  schemeId: string
  /**
   * 所属期别(期数)名称
   */
  issueTitle: string
  /**
   * 所属期别id
   */
  stageId: string
  /**
   * 所属期数id
   */
  issueId: string
  /**
   * 子订单商品年度 属性key
   */
  yearPropertyId: string
  /**
   * 子订单商品年度
   */
  year: string
  /**
   * 子订单商品年度 年度名称
   */
  yearName: string
  /**
   * 子订单商品专业id
   */
  professionId: string
  /**
   * 子订单商品专业id 属性key
   */
  professionPropertyId: string
  /**
   * 子订单商品专业名称
   */
  professionName: string
  /**
   * 子订单商品行业id 属性key
   */
  professionTypePropertyId: string
  /**
   * 子订单商品行业id
   */
  professionTypeId: string
  /**
   * 子订单商品类别、 行业名称
   */
  professionTypeName: string
  /**
   * 子订单实付总价
   */
  subOrderTotalPayAmount: number
  /**
   * 发布机构id
   */
  publishUnitId: string
  /**
   * 发布机构名称
   */
  publishUnitName: string
}

/**
 * 订单详细信息对象
 */
export class OrderInfoDTO {
  /**
   * 订单号
   */
  orderNo: string
  /**
   * 单位ID（培训机构id）
   */
  unitId: string
  /**
   * 买家ID
   */
  buyerId: string
  /**
   * 卖家ID
   */
  sellerId: string
  /**
   * 是否需要发票
   */
  needInvoice: boolean
  /**
   * 发票索要信息
   */
  invoiceInfo: InvoiceRequestDTO
  /**
   * 子订单列表
   */
  subOrderList: Array<SubOrderItemDTO>
  /**
   * 主订单状态
1 - 等待付款
2 - 等待卖家确认款项
3 - 支付成功
4 - 部分发货
5 - 卖家已发货
6 - 交易成功
7 - 交易关闭
8 - 支付中
   */
  orderStatus: number
  /**
   * 订单总金额
   */
  totalAmount: number
  /**
   * 创建方式
1 - 系统创建
2 - 用户自建
3 - 管理员创建
4 - 历史迁移
5 - 外部接口
   */
  createType: number
  /**
   * 订单创建时间, yyyy-mm-dd 24hh:MM:dd
   */
  createTime: string
  /**
   * 完成交易的时间, yyyy-mm-dd 24hh:MM:dd
   */
  completeTime: string
  /**
   * 发货的时间, yyyy-mm-dd 24hh:MM:dd
   */
  deliverTime: string
  /**
   * 订单关闭原因描述
【分页时没有值】
   */
  closeReason: string
  /**
   * 订单关闭原因备注
【分页时没有值】
   */
  closeReasonRemark: string
  /**
   * 失效时间, 在当前秒后失效
   */
  invalidTimeMills: number
  /**
   * 订单支付信息
   */
  payInfo: PayInfoDTO
  /**
   * 支付方式  支付方式 1：线上支付 2：线下支付
   */
  payType: number
  /**
   * 成功付款时间, yyyy-mm-dd 24hh:MM:dd
   */
  payTime: string
  /**
   * 交易渠道信息   web、小程序、公众号
   */
  placeChannel: PaymentChannelTypeEnum
  /**
   * 订单自动关闭时间, yyyy-mm-dd 24hh:MM:dd
   */
  autoCloseTime: string
}

/**
 * 方案详情对象
 */
export class PreExamLSInfoDTO {
  /**
   * 方案id
   */
  schemeId: string
  /**
   * 培训方案名称
   */
  name: string
  /**
   * 考试类别ID
   */
  examTypeId: string
  /**
   * 专业ID
   */
  professionId: string
  /**
   * 年度
   */
  year: number
  /**
   * 封面图片地址
   */
  picture: string
  /**
   * 培训方案状态
@see TrainingConfigStatusConst
   */
  status: number
  /**
   * 发布时间
   */
  publishTime: string
  /**
   * 创建人ID
   */
  createUserId: string
  /**
   * 创建时间
   */
  createTime: string
  /**
   * 方案推荐指数
   */
  recommendIndex: number
  /**
   * 方案列表的讲师信息 一般是方案上外挂的讲师。
详情接口暂时不返回
   */
  teachers: Array<TeacherSimpleDTO>
}

/**
 * 退款订单详情
@author yeyc create 2020/5/6 9:02
 */
export class RefundOrderInfoDTO {
  /**
   * 退款单号
   */
  refundServiceNo: string
  /**
   * 单位ID
   */
  unitId: string
  /**
   * 退款商品ID
   */
  commodityId: string
  /**
   * 主订单号
   */
  refundMasterOrderNo: string
  /**
   * 子订单号
   */
  refundSubOrderNo: string
  /**
   * 是否为虚拟物品
   */
  refundProductVirtual: string
  /**
   * 退款金额
   */
  refundAmount: number
  /**
   * 退款状态
1: 申请退款
2: 申请审核通过
3: 申请拒绝
4: 退款处理中
5: 资源已回收
6: 已退款
7: 拒绝退款
8: 资源回收失败
9: 买家取消退款
10: 退款失败
   */
  refundStatus: number
  /**
   * 退款申请人ID
   */
  applyUserId: string
  /**
   * 退款申请时间
   */
  applyTime: string
  /**
   * 退款原因ID
   */
  reasonId: string
  /**
   * 退款原因描述
   */
  reason: string
  /**
   * 审核时间
   */
  auditTime: string
  /**
   * 确认退款时间(即点击放款的时间)
   */
  affirmRefundTime: string
  /**
   * 退款成功或退款失败的时间(即退款单处于最终退款结果的时间)
   */
  finishTime: string
  /**
   * 创建类型
1：系统创建
2：用户创建
3：管理员创建
4：历史迁移
5: 外部接口
   */
  createType: number
  /**
   * 退款单类型
1：退货不退款
2：退款不退货
3：退货并退款
   */
  type: number
  /**
   * 退款方式
1： 线上 2：线下
   */
  mode: number
  /**
   * 取消退款申请原因描述
   */
  cancelReason: string
  /**
   * 取消退款申请时间
   */
  cancelApplyDate: string
  /**
   * 拒绝申请原因描述
   */
  refuseApplyDesc: string
  /**
   * 拒绝退款原因描述
   */
  refuseRefundDesc: string
  /**
   * 备注
   */
  remark: string
  /**
   * 最后一次更新时间
   */
  lastUpdateTime: string
}

export class SubOrderItemDTO {
  /**
   * 子订单号
   */
  subOrderNo: string
  /**
   * 商品ID
   */
  commodityId: string
  /**
   * 商品名称
   */
  commodityName: string
  /**
   * 商品图片地址
   */
  photoPath: string
  /**
   * 商品规格
   */
  specification: string
  /**
   * 是否为虚拟物品
   */
  virtualGoods: boolean
  /**
   * 商品标价
   */
  labelPrice: number
  /**
   * 成交单价
   */
  dealPrice: number
  /**
   * 购买数量
   */
  purchaseQuantity: number
  /**
   * 子订单实付总价
   */
  totalAmount: number
  /**
   * 子订单状态
待付款 1
未发货 2
发货中 3
已发货 4
买家已签收 5
已换货 6
退货中 7
已退货 8
已取消 9
发货失败 10
已退款(指退货并退款) 11
退货时商品回收失败 12
退货中 13
换货单退货中 14
换货单退货中 15
换货单退货中 16
退货单退款失败 17
退货不退款成功 18
退款不退货成功 19
   */
  orderStatus: number
  /**
   * 是否需要发票
   */
  needBill: boolean
}

export class BillConfigDto {
  /**
   * 发票配置 Id
   */
  id: string
  /**
   * 是否提供发票|1：不提供 2：提供&#x27;
   */
  isProvide: number
  /**
   * 发票提供类型|0：无 1：学员自选是否需要发票 2：强制提供&#x27;
   */
  provideType: number
  /**
   * 支持开票的发票类型 (将会是com.fjhb.courseSupermarket.service.bill.dto.InvoiceTypeEnum里面值的组合或者单个值，例如：COMMON_VAT&amp;-&amp;COMMON_ELECTRON)
   */
  supportInvoiceTypes: string
  /**
   * 支持开票的发票抬头 (将会是com.fjhb.courseSupermarket.service.bill.dto.InvoiceTitleEnum里面值的组合或者单个值，例如：PERSONAL&amp;-&amp;UNIT)
@see InvoiceTitleEnum
   */
  supportInvoiceTitles: string
  /**
   * 是否选择增值税普通发票(发票类型)
   */
  selectCommonVAT: boolean
  /**
   * 是否选择普通电子发票(发票类型)
   */
  selectCommonElectron: boolean
  /**
   * 是否选择增值税专用发票(发票类型)
   */
  selectVATOnly: boolean
  /**
   * 是否选择非税务发票(发票类型)
   */
  selectNonTax: boolean
  /**
   * 是否选择了个人(发票抬头)
   */
  selectPersonal: boolean
  /**
   * 是否选择了单位(发票抬头)
   */
  selectUnit: boolean
}

export class IndustryModel {
  relationId: string
  majorModelList: Array<MajorModel>
  sort: number
  contentType: ContentType
  type: string
  id: string
  name: string
  code: string
  enabled: boolean
}

export class MajorModel {
  relationId: string
  sort: number
  contentType: ContentType
  type: string
  id: string
  name: string
  code: string
  enabled: boolean
}

export class LoginAccountDTO {
  loginType: number
  loginInput: string
  password: string
}

export class TeachAdministratorDTO {
  userId: string
  unitId: string
  name: string
  nickName: string
  uniqueType: number
  uniqueData: string
  status: number
  loginAccounts: Array<LoginAccountDTO>
}

export class UnitDomainDTO {
  id: string
  projectId: string
  subProjectId: string
  unitId: string
  platformId: string
  platformVersionId: string
  domain: string
  domainState: string
}

export class InvoiceRequestDTO {
  title: string
  titleType: number
  type: number
  taxpayerNo: string
  address: string
  phone: string
  bankName: string
  account: string
  email: string
  remark: string
  objectList: Array<InvoiceObjDTO>
  electron: boolean
  noTaxBill: boolean
}

export class InvoiceObjDTO {
  objectType: string
  objectId: string
}

export class TeachUnitPageDTOPage {
  pageSize: number
  pageNo: number
  totalPageSize: number
  totalSize: number
  currentPageData: Array<TeachUnitPageDTO>
}

export class LazyOrderDTOPage {
  pageSize: number
  pageNo: number
  totalPageSize: number
  totalSize: number
  currentPageData: Array<LazyOrderDTO>
}

export class LazyRefundOrderDTOPage {
  pageSize: number
  pageNo: number
  totalPageSize: number
  totalSize: number
  currentPageData: Array<LazyRefundOrderDTO>
}

export class OrderInfoDTOPage {
  pageSize: number
  pageNo: number
  totalPageSize: number
  totalSize: number
  currentPageData: Array<OrderInfoDTO>
}

export class PreExamLSInfoDTOPage {
  pageSize: number
  pageNo: number
  totalPageSize: number
  totalSize: number
  currentPageData: Array<PreExamLSInfoDTO>
}

class DataGateway {
  async _commonQuery<T>(query: DocumentNode, params?: unknown, operation?: string): Promise<Response<T>> {
    return commonRequestApi<T>(SERVER_URL, {
      query: query,
      variables: params,
      operation: operation
    })
  }

  /**   * 验证当前用户是否可以购买订单
   * 500001 商品已购买
   * 500002 存在待支付订单   异常参数：orderNo
   * 500003 有正在学习的期别 异常参数：
   * {
   * 方案名称：name
   * 考试类别id：examTypeId
   * 专业id：professionId
   * 年度：year
   * 期别：issueId
   * }
   * 500004 学习有效期过了
   * 500005 被关闭报名了
   * 500006 所报名的商品不存在
   * expandData 里面都会带对应需要的信息
   * @param
   * @return
   * @param query 查询 graphql 语法文档
   * @param commoditySkuId 参数
   * @param operation graphql 语法文档需要调用的方法
   */
  async checkBeforeCreateOrder(
    commoditySkuId: string,
    query: DocumentNode = GraphqlImporter.checkBeforeCreateOrder,
    operation?: string
  ): Promise<Response<GraphqlOperateResult>> {
    return commonRequestApi<GraphqlOperateResult>(SERVER_URL, {
      query: query,
      variables: { commoditySkuId },
      operation: operation
    })
  }

  /**   * 获取所有行业及专业
   * @return 行业专业关系树
   * @param query 查询 graphql 语法文档
   * @param undefined 参数
   * @param operation graphql 语法文档需要调用的方法
   */
  async findAllIndustryRelationList(
    query: DocumentNode = GraphqlImporter.findAllIndustryRelationList,
    operation?: string
  ): Promise<Response<Array<IndustryModel>>> {
    return commonRequestApi<Array<IndustryModel>>(SERVER_URL, {
      query: query,
      variables: undefined,
      operation: operation
    })
  }

  /**   * 获取施教机构单位id（通过域名）
   * 该接口只返回id和name
   * @param domain
   * @return
   * @param query 查询 graphql 语法文档
   * @param domain 参数
   * @param operation graphql 语法文档需要调用的方法
   */
  async findTeachUnitByDomain(
    domain: string,
    query: DocumentNode = GraphqlImporter.findTeachUnitByDomain,
    operation?: string
  ): Promise<Response<TeachUnitInfoDTO>> {
    return commonRequestApi<TeachUnitInfoDTO>(SERVER_URL, {
      query: query,
      variables: { domain },
      operation: operation
    })
  }

  /**
   * @param query 查询 graphql 语法文档
   * @param ids 参数
   * @param operation graphql 语法文档需要调用的方法
   */
  async findTeachUnitListByIds(
    ids: Array<string>,
    query: DocumentNode = GraphqlImporter.findTeachUnitListByIds,
    operation?: string
  ): Promise<Response<Array<TeachUnitBaseDTO>>> {
    return commonRequestApi<Array<TeachUnitBaseDTO>>(SERVER_URL, {
      query: query,
      variables: { ids },
      operation: operation
    })
  }

  /**   * 获取启用的施教机构分页
   * @param page
   * @return
   * @param query 查询 graphql 语法文档
   * @param params 参数
   * @param operation graphql 语法文档需要调用的方法
   */
  async findTeachUnitPage(
    params: { page?: Page; queryParam?: TeachUnitQueryDTO },
    query: DocumentNode = GraphqlImporter.findTeachUnitPage,
    operation?: string
  ): Promise<Response<TeachUnitPageDTOPage>> {
    return commonRequestApi<TeachUnitPageDTOPage>(SERVER_URL, {
      query: query,
      variables: params,
      operation: operation
    })
  }

  /**   * 获取当前管理员所属施教机构
   * @return
   * @param query 查询 graphql 语法文档
   * @param undefined 参数
   * @param operation graphql 语法文档需要调用的方法
   */
  async findUnitByAdmin(
    query: DocumentNode = GraphqlImporter.findUnitByAdmin,
    operation?: string
  ): Promise<Response<string>> {
    return commonRequestApi<string>(SERVER_URL, {
      query: query,
      variables: undefined,
      operation: operation
    })
  }

  /**   * 获取订单的发票信息
   * @param query 查询 graphql 语法文档
   * @param orderNo 参数
   * @param operation graphql 语法文档需要调用的方法
   */
  async getBillByOrderNo(
    orderNo: string,
    query: DocumentNode = GraphqlImporter.getBillByOrderNo,
    operation?: string
  ): Promise<Response<BillOrderInfoDTO>> {
    return commonRequestApi<BillOrderInfoDTO>(SERVER_URL, {
      query: query,
      variables: { orderNo },
      operation: operation
    })
  }

  /**   * 获取订单号集合发票信息
   * @param query 查询 graphql 语法文档
   * @param orderNos 参数
   * @param operation graphql 语法文档需要调用的方法
   */
  async getBillByOrderNos(
    orderNos: Array<string>,
    query: DocumentNode = GraphqlImporter.getBillByOrderNos,
    operation?: string
  ): Promise<Response<Array<BillOrderInfoDTO>>> {
    return commonRequestApi<Array<BillOrderInfoDTO>>(SERVER_URL, {
      query: query,
      variables: { orderNos },
      operation: operation
    })
  }

  /**   * 根据渠道 查询发票配置信息
   * @param query 查询 graphql 语法文档
   * @param queryParam 参数
   * @param operation graphql 语法文档需要调用的方法
   */
  async getBillConfigByPaymentChannel(
    queryParam: BillConfigQueryDTO,
    query: DocumentNode = GraphqlImporter.getBillConfigByPaymentChannel,
    operation?: string
  ): Promise<Response<BillConfigDto>> {
    return commonRequestApi<BillConfigDto>(SERVER_URL, {
      query: query,
      variables: { queryParam },
      operation: operation
    })
  }

  /**   * 根据期别商品id查询期别商品信息
   * @param query 查询 graphql 语法文档
   * @param commoditySkuId 参数
   * @param operation graphql 语法文档需要调用的方法
   */
  async getIssueByCommoditySkuId(
    commoditySkuId: string,
    query: DocumentNode = GraphqlImporter.getIssueByCommoditySkuId,
    operation?: string
  ): Promise<Response<CommodityInfoDTO>> {
    return commonRequestApi<CommodityInfoDTO>(SERVER_URL, {
      query: query,
      variables: { commoditySkuId },
      operation: operation
    })
  }

  /**   * 查询我的订单详情(多用于学员侧查询，只会查询出自己的订单)
   * @param query 查询 graphql 语法文档
   * @param orderNo 参数
   * @param operation graphql 语法文档需要调用的方法
   */
  async getMyOrderInfo(
    orderNo: string,
    query: DocumentNode = GraphqlImporter.getMyOrderInfo,
    operation?: string
  ): Promise<Response<OrderInfoDTO>> {
    return commonRequestApi<OrderInfoDTO>(SERVER_URL, {
      query: query,
      variables: { orderNo },
      operation: operation
    })
  }

  /**   * 根据订单号查询订单详情(多用于管理侧，权限较大，只要订单号匹配就有订单)
   * 实时查询接口
   * @param query 查询 graphql 语法文档
   * @param orderNo 参数
   * @param operation graphql 语法文档需要调用的方法
   */
  async getOrderInfo(
    orderNo: string,
    query: DocumentNode = GraphqlImporter.getOrderInfo,
    operation?: string
  ): Promise<Response<OrderInfoDTO>> {
    return commonRequestApi<OrderInfoDTO>(SERVER_URL, {
      query: query,
      variables: { orderNo },
      operation: operation
    })
  }

  /**   * 根据方案id查询方案信息
   * @param query 查询 graphql 语法文档
   * @param schemeId 参数
   * @param operation graphql 语法文档需要调用的方法
   */
  async getPreExamLSById(
    schemeId: string,
    query: DocumentNode = GraphqlImporter.getPreExamLSById,
    operation?: string
  ): Promise<Response<PreExamLSInfoDTO>> {
    return commonRequestApi<PreExamLSInfoDTO>(SERVER_URL, {
      query: query,
      variables: { schemeId },
      operation: operation
    })
  }

  /**   * 根据退款单号查询退款订单详情
   * 如果需要取一条，则取最后更新时间最新的就行了
   * 供给学员侧使用
   * @param query 查询 graphql 语法文档
   * @param refundOrderNo 参数
   * @param operation graphql 语法文档需要调用的方法
   */
  async getRefundOrderByNo(
    refundOrderNo: string,
    query: DocumentNode = GraphqlImporter.getRefundOrderByNo,
    operation?: string
  ): Promise<Response<RefundOrderInfoDTO>> {
    return commonRequestApi<RefundOrderInfoDTO>(SERVER_URL, {
      query: query,
      variables: { refundOrderNo },
      operation: operation
    })
  }

  /**   * 根据子订单号查询退款订单详情
   * 如果需要取一条，则取最后更新时间最新的就行了
   * 供给学员侧使用
   * @param query 查询 graphql 语法文档
   * @param subOrderNo 参数
   * @param operation graphql 语法文档需要调用的方法
   */
  async getRefundOrderBySubOrderNo(
    subOrderNo: string,
    query: DocumentNode = GraphqlImporter.getRefundOrderBySubOrderNo,
    operation?: string
  ): Promise<Response<Array<RefundOrderInfoDTO>>> {
    return commonRequestApi<Array<RefundOrderInfoDTO>>(SERVER_URL, {
      query: query,
      variables: { subOrderNo },
      operation: operation
    })
  }

  /**   * 延迟查询退款订单统计信息
   * @param queryParam
   * @return
   * @param query 查询 graphql 语法文档
   * @param queryParam 参数
   * @param operation graphql 语法文档需要调用的方法
   */
  async getRefundStatistics(
    queryParam: LazyRefundOrderParam,
    query: DocumentNode = GraphqlImporter.getRefundStatistics,
    operation?: string
  ): Promise<Response<LazyRefunOrderStatisticsDTO>> {
    return commonRequestApi<LazyRefunOrderStatisticsDTO>(SERVER_URL, {
      query: query,
      variables: { queryParam },
      operation: operation
    })
  }

  /**   * 获取施教机构
   * @param unitId
   * @return
   * @param query 查询 graphql 语法文档
   * @param unitId 参数
   * @param operation graphql 语法文档需要调用的方法
   */
  async getTeachUnit(
    unitId: string,
    query: DocumentNode = GraphqlImporter.getTeachUnit,
    operation?: string
  ): Promise<Response<TeachUnitInfoDTO>> {
    return commonRequestApi<TeachUnitInfoDTO>(SERVER_URL, {
      query: query,
      variables: { unitId },
      operation: operation
    })
  }

  /**   * lazy查询订单
   * 查询二次清洗表，一般用在管理后台
   * @param query 查询 graphql 语法文档
   * @param orderNo 参数
   * @param operation graphql 语法文档需要调用的方法
   */
  async lazyGetOrder(
    orderNo: string,
    query: DocumentNode = GraphqlImporter.lazyGetOrder,
    operation?: string
  ): Promise<Response<LazyOrderDTO>> {
    return commonRequestApi<LazyOrderDTO>(SERVER_URL, {
      query: query,
      variables: { orderNo },
      operation: operation
    })
  }

  /**   * 延迟查询退款订单详情
   * @param refunOrderNo
   * @return
   * @param query 查询 graphql 语法文档
   * @param refunOrderNo 参数
   * @param operation graphql 语法文档需要调用的方法
   */
  async lazyGetRefundOrder(
    refunOrderNo: string,
    query: DocumentNode = GraphqlImporter.lazyGetRefundOrder,
    operation?: string
  ): Promise<Response<LazyRefundOrderDetailsDTO>> {
    return commonRequestApi<LazyRefundOrderDetailsDTO>(SERVER_URL, {
      query: query,
      variables: { refunOrderNo },
      operation: operation
    })
  }

  /**   * lazy查询订单统计
   * 查询二次清洗表，一般用在管理后台
   * @param query 查询 graphql 语法文档
   * @param queryParam 参数
   * @param operation graphql 语法文档需要调用的方法
   */
  async lazyOrderStatistics(
    queryParam: LazyOrderQueryParam,
    query: DocumentNode = GraphqlImporter.lazyOrderStatistics,
    operation?: string
  ): Promise<Response<LazyOrderStatisticsDTO>> {
    return commonRequestApi<LazyOrderStatisticsDTO>(SERVER_URL, {
      query: query,
      variables: { queryParam },
      operation: operation
    })
  }

  /**   * lazy查询订单分页
   * 查询二次清洗表，一般用在管理后台
   * @param query 查询 graphql 语法文档
   * @param params 参数
   * @param operation graphql 语法文档需要调用的方法
   */
  async lazyPageOrder(
    params: { page?: Page; queryParam?: LazyOrderQueryParam },
    query: DocumentNode = GraphqlImporter.lazyPageOrder,
    operation?: string
  ): Promise<Response<LazyOrderDTOPage>> {
    return commonRequestApi<LazyOrderDTOPage>(SERVER_URL, {
      query: query,
      variables: params,
      operation: operation
    })
  }

  /**   * 延迟查询退款订单分页
   * @param page
   * @param queryParam
   * @return
   * @param query 查询 graphql 语法文档
   * @param params 参数
   * @param operation graphql 语法文档需要调用的方法
   */
  async lazyPageRefundOrder(
    params: { page?: Page; queryParam?: LazyRefundOrderParam },
    query: DocumentNode = GraphqlImporter.lazyPageRefundOrder,
    operation?: string
  ): Promise<Response<LazyRefundOrderDTOPage>> {
    return commonRequestApi<LazyRefundOrderDTOPage>(SERVER_URL, {
      query: query,
      variables: params,
      operation: operation
    })
  }

  /**   * 根据渠道和支付类型获取收款账号
   * @param query 查询 graphql 语法文档
   * @param queryParam 参数
   * @param operation graphql 语法文档需要调用的方法
   */
  async listAccount(
    queryParam: MerchantAccountQuery,
    query: DocumentNode = GraphqlImporter.listAccount,
    operation?: string
  ): Promise<Response<Array<StudentMerchantAccountDTO>>> {
    return commonRequestApi<Array<StudentMerchantAccountDTO>>(SERVER_URL, {
      query: query,
      variables: { queryParam },
      operation: operation
    })
  }

  /**   * 根据期别商品id集合查询期别商品信息
   * @return
   * @param query 查询 graphql 语法文档
   * @param commoditySkuIds 参数
   * @param operation graphql 语法文档需要调用的方法
   */
  async listIssueByCommoditySkuIds(
    commoditySkuIds: Array<string>,
    query: DocumentNode = GraphqlImporter.listIssueByCommoditySkuIds,
    operation?: string
  ): Promise<Response<Array<CommodityInfoDTO>>> {
    return commonRequestApi<Array<CommodityInfoDTO>>(SERVER_URL, {
      query: query,
      variables: { commoditySkuIds },
      operation: operation
    })
  }

  /**   * 根据方案id查询期别商品信息
   * @param query 查询 graphql 语法文档
   * @param schemeId 参数
   * @param operation graphql 语法文档需要调用的方法
   */
  async listIssueBySchemeId(
    schemeId: string,
    query: DocumentNode = GraphqlImporter.listIssueBySchemeId,
    operation?: string
  ): Promise<Response<Array<IssueDTO>>> {
    return commonRequestApi<Array<IssueDTO>>(SERVER_URL, {
      query: query,
      variables: { schemeId },
      operation: operation
    })
  }

  /**   * 根据方案id 获取 方案内课程以及讲师
   * @param query 查询 graphql 语法文档
   * @param schemeId 参数
   * @param operation graphql 语法文档需要调用的方法
   */
  async listPreExamLSCourse(
    schemeId: string,
    query: DocumentNode = GraphqlImporter.listPreExamLSCourse,
    operation?: string
  ): Promise<Response<Array<PreExamLSCourseDTO>>> {
    return commonRequestApi<Array<PreExamLSCourseDTO>>(SERVER_URL, {
      query: query,
      variables: { schemeId },
      operation: operation
    })
  }

  /**   * 查询退款原因
   * @return
   * @param query 查询 graphql 语法文档
   * @param undefined 参数
   * @param operation graphql 语法文档需要调用的方法
   */
  async listRefundReason(
    query: DocumentNode = GraphqlImporter.listRefundReason,
    operation?: string
  ): Promise<Response<Array<OrderRefundReasonDTO>>> {
    return commonRequestApi<Array<OrderRefundReasonDTO>>(SERVER_URL, {
      query: query,
      variables: undefined,
      operation: operation
    })
  }

  /**   * 获取所有商品的年度
   * @param query 查询 graphql 语法文档
   * @param undefined 参数
   * @param operation graphql 语法文档需要调用的方法
   */
  async listYear(
    query: DocumentNode = GraphqlImporter.listYear,
    operation?: string
  ): Promise<Response<Array<YearDTO>>> {
    return commonRequestApi<Array<YearDTO>>(SERVER_URL, {
      query: query,
      variables: undefined,
      operation: operation
    })
  }

  /**   * 查询我的订单分页(多用于学员侧查询，只会查询出自己的订单)
   * @param query 查询 graphql 语法文档
   * @param params 参数
   * @param operation graphql 语法文档需要调用的方法
   */
  async pageMyOrder(
    params: { page?: Page; queryParam?: MyOrderQueryDTO },
    query: DocumentNode = GraphqlImporter.pageMyOrder,
    operation?: string
  ): Promise<Response<OrderInfoDTOPage>> {
    return commonRequestApi<OrderInfoDTOPage>(SERVER_URL, {
      query: query,
      variables: params,
      operation: operation
    })
  }

  /**   * 查询已发布的培训方案分页(附带教师信息)
   * @param query 查询 graphql 语法文档
   * @param params 参数
   * @param operation graphql 语法文档需要调用的方法
   */
  async pagePutawayPreExamLS(
    params: { page?: Page; query?: PreExamLSQueryDTO },
    query: DocumentNode = GraphqlImporter.pagePutawayPreExamLS,
    operation?: string
  ): Promise<Response<PreExamLSInfoDTOPage>> {
    return commonRequestApi<PreExamLSInfoDTOPage>(SERVER_URL, {
      query: query,
      variables: params,
      operation: operation
    })
  }

  /**
   * @param mutate 查询 graphql 语法文档
   * @param requestParams 参数
   * @param operation graphql 语法文档需要调用的方法
   */
  async exportBill(
    requestParams: LazyBillRequestParam,
    mutate: DocumentNode = GraphqlImporter.exportBill,
    operation?: string
  ): Promise<Response<boolean>> {
    return commonRequestApi<boolean>(SERVER_URL, {
      query: mutate,
      variables: { requestParams },
      operation: operation
    })
  }

  /**
   * @param mutate 查询 graphql 语法文档
   * @param requestParams 参数
   * @param operation graphql 语法文档需要调用的方法
   */
  async exportOrder(
    requestParams: LazyOrderQueryParam,
    mutate: DocumentNode = GraphqlImporter.exportOrder,
    operation?: string
  ): Promise<Response<boolean>> {
    return commonRequestApi<boolean>(SERVER_URL, {
      query: mutate,
      variables: { requestParams },
      operation: operation
    })
  }

  /**
   * @param mutate 查询 graphql 语法文档
   * @param requestParams 参数
   * @param operation graphql 语法文档需要调用的方法
   */
  async exportRefundOrder(
    requestParams: LazyRefundOrderParam,
    mutate: DocumentNode = GraphqlImporter.exportRefundOrder,
    operation?: string
  ): Promise<Response<boolean>> {
    return commonRequestApi<boolean>(SERVER_URL, {
      query: mutate,
      variables: { requestParams },
      operation: operation
    })
  }
}

export default new DataGateway()
